import { Component, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NotificationMessageDetail, MODAL_WIDTHS } from '../../../domain/types/notification';
import { parseAddresses } from '../../../data-access/notification-addresses';
import { wrapHtmlForIframe } from '../../../data-access/template-renderer';

@Component({
	selector: 'notification-message-modal',
	templateUrl: './notification-message-modal.component.html',
	styleUrls: ['./notification-message-modal.component.scss']
})
export class NotificationMessageModalComponent {
	message: NotificationMessageDetail;
	ccAddresses: string[];
	/** Rendered body, trusted only for use as the sandboxed iframe srcdoc. */
	safeBody: SafeHtml;

	constructor(
		private readonly dialogRef: MatDialogRef<NotificationMessageModalComponent>,
		private readonly sanitizer: DomSanitizer,
		@Inject(MAT_DIALOG_DATA) data: NotificationMessageDetail
	) {
		this.message = data;
		this.ccAddresses = parseAddresses(data.ccAddressesJSON);
		const bodyDoc = wrapHtmlForIframe(data.bodyHtmlRendered || '');
		// The body still runs inside an iframe without allow-scripts or
		// allow-same-origin, so even though we trust it here for the srcdoc
		// binding, scripts and form submissions can't execute.
		this.safeBody = this.sanitizer.bypassSecurityTrustHtml(bodyDoc);
	}

	public static open(md: MatDialog, message: NotificationMessageDetail): MatDialogRef<NotificationMessageModalComponent> {
		return md.open(NotificationMessageModalComponent, { width: MODAL_WIDTHS.wide, data: message });
	}
}
